import React, { createRef } from "react";
import Icon from "components/Varios/Icons.js";
import Select from 'react-select';

import TooltipItem from "components/Varios/Tooltip.js";

export default class SelectItem2 extends React.Component {

    constructor(props) {
        super(props);
        this.selectRef = createRef(); 
    }

    customStyles = {

        singleValue: (provided) => {

            const estilosAdicionales = this.props.stylesInput ? this.props.stylesInput : {}
            return {
                ...provided,
                ...estilosAdicionales,


            }

        },
        container: (provided, state) => {

            return {
                ...provided,
                position: "relative",
                width: "100%",
                marginBottom: "0"
            }
        },
        control: (provided, state) => {
            const backgroundColor = state.isDisabled ? "#E3E3E3" : "#fff";

            return {
                ...provided,
                borderRadius: "4px",
                border: "1px solid #E3E3E3",
                backgroundColor,
                color: "#2c2c2c",
                minHeight: "27px",
                height: "38px",
                fontSize: "14px",
                boxShadow: "none",
                width: "auto",
                fontFamily: "Roboto"
            }
        },
        valueContainer: (provided, state) => {

            const estiloAdicional = this.props.center && this.props.center === true ? { justifyContent: "center" } : {}

            return {
                ...provided,
                ...estiloAdicional
            }
        },
        indicatorSeparator: () => ({
            display: 'none',
        }),
        menu: (provided, state) => ({
            ...provided,
            fontSize: "0.95em",
            //minWidth: "300px",
            zIndex: 9999,
        }),
        menuPortal: (provided, state) => ({
            ...provided,
            zIndex: 9999, // Asegúrate de que el z-index sea mayor que el de otros elementos
        }),
    }

    state = {
        selectedValue: this.props.value,
    };

    handleChange = (selectedValue) => {
        this.setState(
            { selectedValue },
            (() => {
                if (!this.getPropIsMulti(this.props.isMulti)) {
                    this.props.onChange(selectedValue.value, this.props.name, this.props.tipo, selectedValue.label)
                }
                else {
                    this.props.onChange(selectedValue)
                }
            })
            //(() => { this.props.onChange(selectedValue ? selectedValue.value : null, this.props.name, this.props.tipo, selectedValue ? selectedValue.label : "") })
        );
    };

    handleIconClick = () => {
        if (this.selectRef.current) {
            this.selectRef.current.focus(); // ✅ Primero, enfocar el input
            this.selectRef.current.onMenuOpen(); // ✅ Luego, abrir el menú de opciones
        }
    };
    

    handleValueSelect = (value, isMulti) => {

        //el valor que se recibe en value como parametro, puede ser de tipo SelectCombo o cualquier valor, si es SelectCombo
        //debemos solo escoger el value
        if (value.value) {
            value = value.value
        }


        if (value && !isMulti && this.props.options && this.props.options.length > 0) {

            const match = this.props.options.find((obj) => obj.value.toString() === value.toString())

            if (match) {

                return match
            }
            else {
                return null
            }
        }
        else if (isMulti && value) {
            return this.props.value
        }
        else { return null }

    }

    getPropIsMulti = () => {
        if (this.props.isMulti !== undefined) {
            return this.props.isMulti
        }
        else { return false }
    }

    render() {
        const componenteRenderizar = (
            <React.Fragment>
                <Select
                    ref={this.selectRef}
                    options={this.props.options}
                    value={this.handleValueSelect(this.props.value, this.getPropIsMulti())}
                    onChange={this.handleChange}
                    styles={this.customStyles}
                    placeholder={this.props.placeholder}
                    name={this.props.name}
                    id={this.props.id}
                    isDisabled={(this.props.disabled)}
                    isRequired={true}
                    isMulti={this.getPropIsMulti()}
                    isSearchable={this.props.isSearchable !== undefined ? this.props.isSearchable : true}
                    required={this.props.required !== undefined ? this.props.required : false}
                    maxMenuHeight={this.props.maxMenuHeight ? this.props.maxMenuHeight : 200}
                    menuPortalTarget={this.props.menuPortalTarget ? this.props.menuPortalTarget : ""}
                //isClearable={true}
                />
                <div 
                    onClick={this.handleIconClick}
                    className={this.props.classNameIcon ?? "icon-inside-select"} 
                    style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}
                >
                    {this.props.icon.startsWith("fa-") ? (<i className={"fas " + this.props.icon} aria-hidden="true"></i>) : (<Icon kind={this.props.icon} fill='#FF0000' width={this.props.iconSize ?? 10} height={this.props.iconSize ?? 10} />)}
                </div>
{/* 
                {
                    ((this.props.disabledHover !== undefined && this.props.disabledHover === false && this.props.placeholder) || (this.props.disabledHover === undefined)) &&
                    <TooltipItem content={this.props.placeholder} id={this.props.id} />

                } */}
            </React.Fragment>
        )

        if (this.props.rowRender !== undefined && this.props.rowRender) {
            return (componenteRenderizar)
        }
        return (
            <div className="input-group" > 
                {componenteRenderizar}
            </div>
        )

    }
}